/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Person_InactiveInputs */

const fr_api_person_inactive = /** @type {(inputs: Api_Person_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce compte est inactif. Contactez un administrateur.`)
};

const en_api_person_inactive = /** @type {(inputs: Api_Person_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account is inactive. Contact an administrator.`)
};

/**
* | output |
* | --- |
* | "This account is inactive. Contact an administrator." |
*
* @param {Api_Person_InactiveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_person_inactive = /** @type {((inputs?: Api_Person_InactiveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Person_InactiveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_person_inactive(inputs)
	return fr_api_person_inactive(inputs)
});